var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('navbar'),_vm._v(" "),_c('section',{staticClass:"pa-10 f1"},[_c('div',{staticClass:"container"},[_c('home')],1)]),_vm._v(" "),_c('footbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }